declare namespace $ {

	type $mol_check_expand__checked_shm_wordstat_filter_section_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_section['expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_wordstat_filter_section_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_view__sub_shm_wordstat_filter_section_3 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_section['title_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_filter_section_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_wordstat_filter_section extends $mol_list {
		section_rows( ): readonly(any)[]
		expanded( next?: boolean ): boolean
		Expand( ): $mol_check_expand
		Label( ): $mol_view
		title( ): string
		title_content( ): readonly(any)[]
		content( ): readonly(any)[]
		rows( ): ReturnType< $shm_wordstat_filter_section['section_rows'] >
		Title( ): $mol_view
	}
	
}

//# sourceMappingURL=section.view.tree.d.ts.map